<template>
    <div>
        <div class="title">Вы не добавили обучение для следующих целей</div>
        <ul class="list">
            <li
                class="list-item"
                v-for="item in links"
                :key="item.id"
            >
                <router-link :to="item.to">{{ item.name }}</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'UserPopupCompetence',
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    computed: {
        links() {
            return this.items.map(v => ({
                id: v.id,
                name: v.name,
                to: {
                    name: v.competenceType === 'hard' ? 'professional-skill' : 'competence',
                    params: { id: v.id },
                },
            }));
        },
    },
};
</script>

<style scoped lang="scss">

    .list {
        max-height: 230px;
        overflow: scroll;
    }
    .title {
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        text-align: center;
        color: #2A2626;
        margin: 8px 0 16px;
    }

    .list {
        margin-top: 12px;

        &::-webkit-scrollbar {
            height: auto;
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #E1E1E1;
            border-radius: 0.3rem;
        }

        &::-webkit-scrollbar-track {
            background: none;
        }

        &-item {
            font-style: normal;
            font-weight: normal;
            font-size: 15px;
            line-height: 22px;
            color: #2A2626;
            padding-left: 24px;
            background:  url("../../../../../assets/images/account-track/icon/competence.svg") no-repeat left 3px;
        }
    }

    li {
        margin-bottom: 12px;

        &:last-of-type {
            margin: 0;
        }
    }

    ul  {
        list-style:none;
        padding-left:0;
        margin: 0;
    }
</style>